import { render, staticRenderFns } from "./roleMange.vue?vue&type=template&id=65999149&scoped=true&"
import script from "./roleMange.vue?vue&type=script&lang=js&"
export * from "./roleMange.vue?vue&type=script&lang=js&"
import style0 from "./roleMange.vue?vue&type=style&index=0&id=65999149&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65999149",
  null
  
)

export default component.exports